import { classNames } from 'primereact/utils'

const button = {
    root: ({ props, context, parent }: { props: any; context: any; parent: any }) => {
        const isPrimary =
            !props.link &&
            !props.severity &&
            !props.text &&
            !props.outlined &&
            !props.plain
        const isSecondary =
            props.severity === 'secondary' &&
            !props.text &&
            !props.outlined &&
            !props.plain
        const isContrast =
            props.severity === 'contrast' &&
            !props.text &&
            !props.outlined &&
            !props.plain
        const isInfo =
            props.severity === 'info' &&
            !props.text &&
            !props.outlined &&
            !props.plain
        const isDanger =
            props.severity === 'danger' &&
            !props.text &&
            !props.outlined &&
            !props.plain

        return {
            className: classNames(
                'relative',
                'text-base',
                // Alignments
                'items-center inline-flex text-center align-bottom justify-center',
                // Sizes & Spacing
                'leading-[normal]',
                {
                    'px-4 py-2.5': props.size === null && !props['data-has-tag'],
                    'px-4 py-2': props.size === null && props['data-has-tag'],
                    'text-sm py-2 px-3': props.size === 'small',
                    'text-xxl py-3 px-4': props.size === 'large',
                },

                {
                    'w-10 h-10 p-0 py-3 gap-0':
                        props.label === null && props.icon !== null,
                },
                {
                    'gap-2': props.label && props.icon,
                },
                // Shapes
                {
                    'rounded-full': props.rounded && !props.text,
                    rounded: props.rounded === false && !props.text,
                },
                {
                    "rounded-none first:rounded-l-md last:rounded-r-md":
                    parent === "InputGroup",
                },
                // Link Button
                {
                    'text-primary-600 bg-transparent border-transparent':
                        props.link,
                },

                // Plain Text Button
                { 'text-surface-500': props.plain && props.text },
                // Text Button
                {
                    'bg-transparent border-transparent':
                        props.text && !props.plain,
                },

                // Borders
                { 'border-2 border-solid': !props.text },

                // Weight
                { 'font-bold': !props.text },
                // --- Severity Buttons ---
                // Primary Button
                {
                    'text-allstate-navy': isPrimary,
                    'bg-accent-green hover:bg-white': isPrimary,
                    'border-accent-green ': isPrimary,
                },
                // Secondary
                {
                    'bg-white': isSecondary,
                    'bg-grey-2': context.disabled && isSecondary,
                    'text-allstate-blue': isSecondary,
                    'border-grey-4 hover:border-allstate-light-blue':
                        isSecondary,
                },

                // Info
                {
                    'bg-allstate-light-blue hover:bg-white':
                        isInfo && !props.rounded,
                    'border-allstate-light-blue ': isInfo && !props.rounded,

                    // rounded info
                    'bg-faded-blue  hover:bg-white': isInfo && props.rounded,
                    'border-faded-blue ': isInfo && props.rounded,
                },

                // Contrast
                {
                    'bg-grey-4 hover:bg-white': isContrast,
                    'border-grey-4 ': isContrast,
                },

                // Danger
                {
                    'text-white hover:text-allstate-navy': isDanger,
                    'bg-warning-red hover:bg-white': isDanger,
                    'border-warning-red ': isDanger,
                },

                'focus:ring-2 focus:ring-offset-2 focus:allstate-light-blue',

                // Disabled
                {
                    'opacity-60 pointer-events-none cursor-default':
                        context.disabled,
                },

                // Misc
                'cursor-pointer overflow-hidden select-none'
            ),
        }
    },

    label: ({ props }: { props: any }) => ({
        className: classNames(
            'duration-200',
            'font-bold',
            { 'hover:underline': props.link },
            {
                // 'flex-1': props.label !== null,
                'invisible w-0': props.label === null,
            },
        ),
    }),

    icon: ({ props }: { props: any }) => ({
        className: classNames('mx-0', {
            // 'mr-2': props.iconPos === 'left' && props.label != null,
            'order-1': props.iconPos === 'right' && props.label != null,
            'mb-2': props.iconPos === 'top' && props.label != null,
            'mt-2': props.iconPos === 'bottom' && props.label != null,
        }),
    }),

    loadingIcon: ({ props }: { props: any }) => ({
        className: classNames('mx-0 mr-2 animate-spin', {
            'mr-2':
                props.loading && props.iconPos == 'left' && props.label != null,
            'ml-2 order-1':
                props.loading &&
                props.iconPos == 'right' &&
                props.label != null,
            'mb-2':
                props.loading && props.iconPos == 'top' && props.label != null,
            'mt-2 order-2':
                props.loading &&
                props.iconPos == 'bottom' &&
                props.label != null,
        }),
    }),
    badge: ({ props }: { props: any }) => ({
        className: classNames({
            'w-[20px] h-[20px] text-xs leading-none flex self-center !p-0 items-center justify-center -my-1':
                props.badge,
        }),
    }),
}

export default button
